import type { Meta, StoryObj } from "@storybook/react";

import type { RichTextProps } from "@/ui/core";
import { RichText } from "@/ui/core";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<RichTextProps> = {
  title: "Core/RichText",
  component: RichText,
  argTypes: {
    color: { control: "text" },
    text: { control: "text" },
    variant: { control: "select", options: ["body", "caption"] },
  },
  args: {
    text: "Hello **world**, this is **rich text**.",
    variant: "body",
  },
  render: (args) => (
    <Box width="100%">
      <RichText {...args} />
    </Box>
  ),
};

type Story = StoryObj<RichTextProps>;

const Primary: Story = {};

const Caption: Story = {
  args: {
    text: "Review complete **1-2 business days**",
    variant: "caption",
  },
};

const MultipleBoldSegments: Story = {
  args: {
    text: "Our provider found that **Equip may not be the right fit right now.** Someone from our team will reach out shortly to talk through your options and help you find the right care.",
  },
};

const WithColor: Story = {
  args: {
    color: ColorToken.NeutralSecondary,
    text: "There's **nothing you need to do right now** — we'll let you know when we're done.",
  },
};

const NoBoldMarkers: Story = {
  args: {
    text: "This is plain text without any bold markers.",
  },
};

export { Caption, MultipleBoldSegments, NoBoldMarkers, Primary, WithColor };
export default StoryMeta;
